import {
  Component,
  AfterContentInit,
  ElementRef,
  Optional,
  OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PlycaDataService } from '../../../services/plyca.service';
import { PaginationDTO } from '../../api/PaginationModel';
import {
  AuditTaskDTO,
  Link,
  ProcedureDTO
} from '../../api/plyca-dtos';
import { ProjectEntityDTO } from '../../api/plyca-dtos-v2';
import { UserService } from '../../user.service';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { ServiceLocator } from '../../ServiceLocator';
import { TranslateService } from '@ngx-translate/core';
import { Observable, forkJoin, throwError } from 'rxjs';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { InboxUsersComponent } from './inboxusers.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

@Component({
  selector: 'audit',
  templateUrl: 'audit.template.html',
  providers: [DialogService]
})
export class AuditComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  private userService: UserService;
  private uiService: UIService;

  isModalWindow = false;
  visibleDetalle = false;
  moreDetailsProcedure = false;
  lessDetailsProcedure = true;

  dossierId = 'Sin Información';
  procedureId: string;
  loaded = false;
  showHeader = true;

  textFilter = '';
  pendingTasksFilter = false;
  internalProcesses = false;

  auditListCompleted: AuditTaskDTO[];
  auditListRunning: AuditTaskDTO[];
  filteredAuditList: AuditTaskDTO[];
  pagLinks: Link[];

  dossier: ProjectEntityDTO;
  procedure: ProcedureDTO;
  tagsParent: string[];
  windowHash: string;

  constructor(
    private route: ActivatedRoute,
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    private translate: TranslateService,
    private waitService: WaitLoadingService,
    private elem: ElementRef,
    private headerService: HeaderActionsService,
    private dialogService: DialogService,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig
  ) {
    super();
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => this.tagsParent = helpTags)));
    if (dialogConfig && JSON.stringify(dialogConfig) != '{}') {
      this.dossierId = dialogConfig['id'];
      this.procedureId = dialogConfig['procedureId'];
      this.isModalWindow = true;
    } else {
      this.subscribe(route.params, params => {
        this.dossierId = params['id'];
      });
      this.subscribe(route.queryParams, params => {
        this.procedureId = params['procedureId'];
      });
    }

    this.userService = ServiceLocator.injector.get(UserService);
    this.uiService = ServiceLocator.injector.get(UIService);
  }

  addActions() {
    this.windowHash = generateRandomIdentifier();
    if (this.isModalWindow) {
      this.headerService.clearWindowActions(this.windowHash);
      this.subscribe(this.headerService
        .addWindowAction('Actualizar', 'fas fa-lg fa-sync-alt', 'btn-primary', true, this.windowHash),
        () => {
          this.load();
        });
    } else {
      this.headerService.clearActions();
      this.subscribe(this.headerService
        .addAction('Actualizar', 'fas fa-lg fa-sync-alt', 'btn-primary', true),
        () => {
          this.load();
        });
      this.headerService.addDivider();
      this.subscribe(this.headerService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        ),
        () => {
          this.uiService.routeBack();
        });
    }
  }

  ngAfterContentInit(): void {
    this.load();
  }

  public isLoaded() {
    return this.loaded;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.isModalWindow) {
      this.headerService.clearWindowActions(this.windowHash);

    } else {
      this.headerService.clearActions();
    }
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {


        this.dialogService = null;
        this.dialogConfig = null;

      })));
  }

  close() {
    try {
      this.ref.close();

    } catch (e) {
      console.log(e);
    }
  }

  load() {
    this.waitService.startWaiting();
    let runningRequest: Observable<PaginationDTO<AuditTaskDTO>>;
    let auditRequest: Observable<PaginationDTO<AuditTaskDTO>>;
    if (!this.procedureId) {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.DOSSIER_AUDIT));
      auditRequest = this.plycaService.getAuditTasksExp(this.dossierId);
      runningRequest = this.plycaService.getAuditTasksExp(
        this.dossierId,
        true
      );
    } else {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.AUDIT_TRAM));
      auditRequest = this.plycaService.getAuditTasksProcedure(
        this.dossierId,
        this.procedureId,
        false,
        this.internalProcesses
      );
      runningRequest = this.plycaService.getAuditTasksProcedure(
        this.dossierId,
        this.procedureId,
        true
      );
    }

    this.subscribe(forkJoin(
      runningRequest,
      auditRequest
    ).pipe(
      catchError((error: any) => {
        return throwError(error);
      }),
      finalize(() => {
        this.addActions();
        this.loaded = true;
        this.waitService.cancelWaiting();
      })
    ), result => {
      let _allAudit = [];
      if (result[0] && result[0].content) {
        this.auditListRunning = result[0].content;
        _allAudit = _allAudit.concat(this.auditListRunning);
      }
      if (result[1] && result[1].content) {
        this.auditListCompleted = result[1].content;
        _allAudit = _allAudit.concat(this.auditListCompleted);
      }
      // RECUPERAR REFERENCIA A DOSSIER DEL PRIMER ELEMENTO
      if (_allAudit && _allAudit[0] && _allAudit[0].project) {
        this.dossier = _allAudit[0].project;
        this.procedure = _allAudit[0].procedure;
      }
      // _allAudit = _allAudit.reverse();
      this.filteredAuditList = _allAudit;
      this.loaded = true;
      this.updateFilter();
    })
  }

  public existsAuditData(): boolean {
    // Puede no existir auditoria de usuario o de tareas vivas
    // y existir auditoria de PAs. En ese caso hay que dejar
    // que el usuario elimine filtros para verlo
    return true;
  }

  public updateFilter() {
    let _searchText = this.textFilter;
    let _searchPendingTasks = this.pendingTasksFilter;

    if (this.auditListCompleted) {
      this.filteredAuditList = this.auditListCompleted.concat(
        this.auditListRunning
      );
    } else {
      this.filteredAuditList = this.auditListRunning;
    }

    if (this.filteredAuditList) {
      this.filteredAuditList = this.filteredAuditList.filter(function (d: any) {
        if (d) {
          let isTextFiltered: boolean =
            d.description?.toLowerCase().indexOf(_searchText.toLowerCase()) !==
            -1;
          let isPendingFiltered: boolean =
            !_searchPendingTasks || (_searchPendingTasks && !d.dateDesp);
          return isTextFiltered && isPendingFiltered;
        }
      });
    }
  }

  showInbox(element: AuditTaskDTO) {




    let config: DynamicDialogConfig = {
      header: this.translate.instant('Audit.UsersTaskAccess.title') + ': (' + element.inbox.identifier + ') ' + element.inbox.name + '.',
      width: '60%',
      style: { 'max-height': '60%' },
      styleClass: 'helpStyle'
    };


    config['taskId'] = element.swIdTask;

    config['inboxId'] = element.inbox.identifier;
    config['inboxDescription'] = element.inbox.name;


    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));
    const ref = this.dialogService.open(InboxUsersComponent, config);

    this.subscribe(ref.onClose,
      () => {
        this.subscribe(this.helpService.showContextHelpObservable(curentHelpTags));
      });
  }

  public getStatusTooltip(element: any): string {
    let txt = undefined;
    if (element.taskId.startsWith('R~')) {
      txt = this.translate.instant('Audit.redirectTask');
      let idElements = element.taskId.split('~');
      txt += ' [' + idElements[2] + ' ]';
    }


    return txt;
  }
}
